import { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { A11y, EffectFade, Autoplay, Navigation } from 'swiper/modules';
import { useSettings } from '@backpackjs/storefront';
import { Svg } from '../Svg';
import { Link } from '../Link';

export function Promobar({
  promobarDisabled,
  promobarHidden,
  setPromobarHidden,
}) {
  const settings = useSettings();
  const { promobar } = { ...settings?.header };
  const { autohide, delay, enabled, messages, speed } = {
    ...promobar,
  };

  const [promoBarCloseClick, setPromoBarCloseClick] = useState(false);

  const swiperParams = {
    autoplay: {
      delay: delay || 5000,
      disableOnInteraction: false,
    },
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    loop: messages?.length > 1,
    modules: [A11y, Autoplay, EffectFade, Navigation],
    speed: speed || 500,
    style: {
      '--swiper-navigation-color': '#FFFFFF',
      '--swiper-navigation-size': '12px',
    },
  };

  const closePromoBar = () => {
    setPromoBarCloseClick(true);
    setPromobarHidden(true);
  };

  useEffect(() => {
    const setPromobarVisibility = () => {
      if (document.body.style.position === 'fixed') return;
      setPromobarHidden(window.scrollY > 48);
    };

    if (!autohide) {
      setPromobarHidden(false);
      window.removeEventListener('scroll', setPromobarVisibility);
      return undefined;
    }

    window.addEventListener('scroll', setPromobarVisibility);
    return () => {
      window.removeEventListener('scroll', setPromobarVisibility);
    };
  }, [autohide]);

  return (
    <div
      className={`relative overflow-hidden bg-[#CCE0F1] transition-[height] ease-out print:hidden ${
        promoBarCloseClick || promobarHidden || promobarDisabled
          ? 'h-0 duration-[50ms]'
          : 'h-[var(--promobar-height)] duration-300'
      }`}
    >
      {enabled && messages?.length ? (
        <>
          <Swiper
            {...swiperParams}
            className="swiper-wrapper-center relative flex h-full items-center"
          >
            {messages.map(({ message, link }, index) => {
              return (
                <SwiperSlide key={index} className="px-6">
                  <div className="px-contained flex min-h-full items-center justify-center text-center text-xs tracking-[0.04em] text-black sm:text-sm">
                    {link?.url ? (
                      <Link
                        className="select-none"
                        draggable={false}
                        href={link.url}
                        newTab={link.newTab}
                      >
                        {message}
                      </Link>
                    ) : (
                      <span>{message}</span>
                    )}
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>

          <button
            type="button"
            aria-label="Close promo bar"
            className="absolute right-2 top-1/2 z-10 -translate-y-1/2 cursor-pointer p-1 md:right-6 xl:right-10"
            onClick={() => closePromoBar()}
          >
            <Svg
              className="w-3 text-text"
              src="/svgs/close.svg#close"
              title="Close"
              viewBox="0 0 24 24"
            />
          </button>
        </>
      ) : null}
    </div>
  );
}

Promobar.displayName = 'Promobar';
